import {
  UseMutationOptions,
  useMutation,
  useQueryClient,
} from '@tanstack/react-query';
import {
  MyProfileParam,
  PublisherProfileResource,
  publishersSetProfile,
} from '~/generated';
import { extractData } from '~/utils/query-utils';

export const usePublisherSetProfile = (
  id: number,
  options: UseMutationOptions<
    PublisherProfileResource,
    unknown,
    MyProfileParam,
    unknown
  > = {}
) => {
  const queryClient = useQueryClient();
  return useMutation({
    ...options,
    mutationFn: (profile: MyProfileParam) =>
      extractData(publishersSetProfile({ path: { id }, body: profile })),
    onSuccess(...args) {
      queryClient.invalidateQueries({
        queryKey: ['publishers', 'profile', id],
      });
      options.onSuccess?.(...args);
    },
  });
};
